import { Suspense, lazy } from 'react';
import { createBrowserRouter } from "react-router-dom";


//dynamic route components
import Layout from './pages/Layout';
import Home from './pages/Home';
import Loader from './components/UI/Loader';
import ErrorPage from './pages/ErrorPage';

const SoftwareEngineering = lazy(() => import('./pages/SoftwareEngineering'));
const OurConsultant = lazy(() => import('./pages/OurConsultant'));
const ManagementConsultancy = lazy(() => import('./pages/ManagementConsultancy'));
const DesignPrint = lazy(() => import('./pages/DesignPrint'));
const Iot = lazy(()=>import("./pages/Iot"));
const IndustrialAutomation = lazy(()=>import("./pages/IndustrialAutomation"));
const ElectricalEngineering = lazy(()=>import("./pages/ElectricalEngineering"));

export default createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            {
                path: '/',
                element: <Home />
            },
            {
                path: 'software-engineering',
                element: <Suspense fallback={<Loader/>}><SoftwareEngineering /></Suspense>
            },
            {
                path: 'management-consultancy',
                element: <Suspense fallback={<Loader/>}><ManagementConsultancy /></Suspense>
            },
            {
                path: '3d-design-print',
                element: <Suspense fallback={<Loader/>}><DesignPrint /></Suspense>
            },
            {
                path: 'iot',
                element: <Suspense fallback={<Loader/>}><Iot /></Suspense>
            },
            {
                path: 'industry-solutions',
                element: <Suspense fallback={<Loader/>}><IndustrialAutomation /></Suspense>
            },
            {
                path: 'electrical-engineering',
                element: <Suspense fallback={<Loader/>}><ElectricalEngineering /></Suspense>
            },
            {
                path: 'our-consultants',
                element: <Suspense fallback={<Loader/>}><OurConsultant /></Suspense>
            }
        ],
        errorElement: <ErrorPage />
    }
]);